module.exports = __webpack_public_path__ + "static/media/care_device_home.f0a44049.svg";